import React from "react";
import clickSoundEffect from "../../../../assets/audio/click.wav";
import { useAudioEffects } from "../../../../hooks/use-audio-effects";

type CustomButtonProps = {
  className?: string;
  variant: "neutral" | "yellow" | "red" | "blue" | "gray" | "light-gray";
  children: React.ReactNode;
  innerClassName?: string;
  disableHoverTranslate?: boolean;
  outlineStyle?: React.CSSProperties;
  innerStyle?: React.CSSProperties;
  disableAudioEffect?: boolean;
};

type Props = CustomButtonProps & React.ButtonHTMLAttributes<HTMLButtonElement>; // <-- All native button props

const variantBgGradient = {
  neutral: "radial-gradient(circle, #566AFF29 0%, #292d4f 100%)",
  yellow: "radial-gradient(circle, #4b522f 0%, #2e3228 100%)",
  red: "radial-gradient(circle, #50272d 0%, #2b1d24 100%)",
  blue: "radial-gradient(circle, #1B6D73 0%, #263642 100%)",
  gray: "radial-gradient(circle, #2e3038 0%, #282a34 100%)",
  "light-gray": "radial-gradient(circle, #424455 0%, #282a34 100%)",
};

const variantBorderGradient = {
  neutral: "",
  yellow: "radial-gradient(circle, #dff453 0%, #565e32 100%)",
  red: "radial-gradient(circle, #db4d4e 0%, #5a2a2f 100%)",
  blue: "radial-gradient(circle, #56F5FF 0%, #2E4557 100%)",
  gray: "linear-gradient(to bottom, #525B61 0%, rgba(82,91,97,0) 70%)",
  "light-gray": "linear-gradient(to bottom, #525B61 0%, rgba(82,91,97,0) 70%)",
};

const Button = ({
  className = "",
  children = <></>,
  variant = "neutral",
  innerClassName = "",
  disableHoverTranslate,
  outlineStyle = {},
  innerStyle = {},
  disableAudioEffect,
  ...buttonProps // <-- Spread all native button props here
}: Props) => {
  const { playEffect } = useAudioEffects();

  return (
    <div
      onClick={() => {
        if (!disableAudioEffect) {
          playEffect(clickSoundEffect);
        }
      }}
      style={{
        background: variantBorderGradient[variant],
        ...outlineStyle,
      }}
      className={`p-[1px] hover:opacity-80 transition rounded-md ${
        !disableHoverTranslate && "hover:translate-x-[0.8%]"
      } ${className}`}
    >
      <button
        {...buttonProps} // <-- Native props applied here
        style={{
          background: variantBgGradient[variant],
          ...innerStyle,
        }}
        className={`w-full p-[6px] rounded-md z-[2] ${innerClassName}`}
      >
        {children}
      </button>
    </div>
  );
};

export default Button;
